import {Component, inject, OnInit} from '@angular/core';
import {
  RefModelSidebarBaseTab,
  RefModelSidebarService,
  RefModelSidebarSubTabs
} from '@q9elements/ui-kit/refmodels';

@Component({
  selector: 'q9rme-node-insight-tab',
  templateUrl: './insight-tab.component.html',
  styleUrls: ['./insight-tab.component.scss']
})
export class InsightTabComponent extends RefModelSidebarBaseTab implements OnInit {
  private refModelSidebarService = inject(RefModelSidebarService);

  public dependenciesTabCount = this.refModelSidebarService.dependenciesTabCount;

  override selectedTab = RefModelSidebarSubTabs.DependenciesTab;

  override ngOnInit() {
    super.ngOnInit();
  }
}
